import { Placement  } from '@popperjs/core/lib'
export interface PopoverProps {
    placement?: Placement;
    trigger?: PopoverTrigger;
    disabled?:boolean;
    showCaret?: boolean;
    persistent?: boolean;
}

export enum PopoverTrigger
{
    Click = "Click",
    Manual = "Manual",
    Focus = "Focus",    
    Hover = "Hover",
}

export enum PopoverEvents {
    PopoverHide = 'popover-hide',
    PopoverHidden = 'popover-hidden',
    PopoverShow = 'popover-show',
    PopoverShown = 'popover-shown',
}